import { useState } from 'react';
import { checkIsClientSide } from '../utils/checkIsClientSide';

export function useLocalStorage<T>(key: string, initialValue: T): [T, (s: T) => void] {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      if (!checkIsClientSide()) {
        return initialValue;
      }
      const item = window.localStorage.getItem(key);
      if (typeof item === 'string') {
        return item;
      }
      return item ? JSON.parse(item) : initialValue;
    } catch {
      return initialValue;
    }
  });

  const setValue = (value: T) => {
    const valueToStore = value instanceof Function ? value(storedValue) : value;
    setStoredValue(valueToStore);
    window.localStorage.setItem(key, JSON.stringify(valueToStore));
  };

  return [storedValue, setValue];
}
